import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
} 


export const isIframe = window.self !== window.top;

export function formatPrice(value) {
  if (value == null) return "0";
  return Number(value).toLocaleString("en-US");
}

/** Convert arbitrary text to a URL-safe slug: lowercase alphanumeric + hyphens only. */
export function slugify(text) {
  return (text || "")
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/**
 * Timestamp display helpers.
 *
 * The platform stores timestamps as ISO strings WITHOUT a timezone designator
 * (e.g. "2026-08-11T06:02:00.000000"). `new Date()` parses such strings as
 * LOCAL time, so a 10:02 AM Dubai (UTC+4) value stored as 06:02 UTC is misread
 * as 06:02 local and rendered as "06:02 AM". These helpers normalize the input
 * to a real UTC instant (append "Z" when a timezone designator is missing),
 * then the toLocale* methods convert that instant to the viewer's local
 * timezone for display. Storage is unchanged.
 *
 * Date-only calendar fields ("YYYY-MM-DD") are parsed as local midnight so the
 * same calendar date renders in every timezone.
 */
const DATE_ONLY_RE = /^\d{4}-\d{2}-\d{2}$/;

export function toLocalDate(value) {
  if (!value) return null;
  const s = String(value);
  if (DATE_ONLY_RE.test(s)) return new Date(s + "T00:00:00");
  // Datetime without a timezone designator: treat as UTC.
  if (/[Tt]\d{2}:\d{2}/.test(s) && !/(Z|[+-]\d{2}:?\d{2})$/.test(s)) {
    return new Date(s + "Z");
  }
  return new Date(s);
}

export function formatLocalDateTime(value, options) {
  const d = toLocalDate(value);
  return d ? d.toLocaleString(undefined, options) : "";
}

export function formatLocalDate(value, options) {
  const d = toLocalDate(value);
  return d ? d.toLocaleDateString(undefined, options) : "";
}

export function formatLocalTime(value, options) {
  const d = toLocalDate(value);
  return d ? d.toLocaleTimeString(undefined, options) : "";
}

export function formatRelativeTime(value) {
  const d = toLocalDate(value);
  if (!d) return "";
  const diff = Date.now() - d.getTime();
  const abs = Math.abs(diff);
  const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });
  const units = [
    ["year", 31536000000],
    ["month", 2629800000],
    ["day", 86400000],
    ["hour", 3600000],
    ["minute", 60000],
    ["second", 1000],
  ];
  for (const [unit, ms] of units) {
    if (abs >= ms || unit === "second") {
      return rtf.format(Math.round(diff / ms), unit);
    }
  }
  return "";
}